// Number formatting helpers. Keep in sync with the Go CLI's table
// formatting in internal/cli/table.go so the HTML UI and the terminal
// UI render the same numbers the same way.

export function percent(v: number | null, digits = 0): string {
  if (v == null || !Number.isFinite(v)) return "–";
  return `${(v * 100).toFixed(digits)}%`;
}

export function signedPercent(v: number | null, digits = 0): string {
  if (v == null || !Number.isFinite(v)) return "–";
  const sign = v >= 0 ? "+" : "";
  return `${sign}${(v * 100).toFixed(digits)}%`;
}

export function money(v: number): string {
  if (!Number.isFinite(v)) return "–";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

export function price(v: number): string {
  if (!Number.isFinite(v)) return "–";
  return v.toFixed(2);
}

export function ratio(v: number | null): string {
  if (v == null || !Number.isFinite(v)) return "–";
  return `${v.toFixed(1)}x`;
}

// dollarCompact renders USD magnitudes in the compact "$1.2M / $50M /
// $1.5B" form that the main table and scanner table use for the
// avg_dollar_volume column. Null, non-finite, or non-positive values
// render as a dash so a cached-but-uncomputed row doesn't show a
// misleading "$0". Falls back to Intl.NumberFormat compact notation
// so K/M/B suffixes stay locale-stable.
export function dollarCompact(v: number | null): string {
  if (v == null || !Number.isFinite(v) || v <= 0) return "–";
  const formatted = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  }).format(v);
  return `$${formatted}`;
}
